import { useMemo } from 'react';
import { getRouteApi } from '@tanstack/react-router';
import { useUrlSyncedFilters } from '@/hooks/useUrlSyncedFilters';
import { toUploadFilterSearch, toUploadFilterValues } from '../utils/questionFilters';

const route = getRouteApi('/_auth/question/upload');

const normalizeFilterValues = (values: Record<string, string>) =>
  toUploadFilterValues(toUploadFilterSearch(values));

export function useUploadFilters() {
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const appliedValues = useMemo(() => toUploadFilterValues(search), [search]);

  const filters = useUrlSyncedFilters({
    appliedValues,
    shouldWaitForApply: true,
    normalizeValues: normalizeFilterValues,
    onApply: (values) => {
      void navigate({
        search: (previous) => ({ ...previous, ...toUploadFilterSearch(values) }),
        replace: true,
      });
    },
  });

  const navigateToProject = (projectId: number) =>
    navigate({
      search: (previous) => ({ ...previous, projectId }),
      replace: true,
    });

  return { ...filters, search, navigateToProject };
}
